module.exports = __webpack_public_path__ + "img/video_pass_btn.9c41af50.png";